import pythonApiClient from './pythonBaseApi';

/**
 * Sincronización alojamiento → proveedor externo (Logiflex / Cumbrak)
 * Operaciones: reserva | checkin | checkout
 */
export const TIPO_OPERACION = {
  RESERVA: 'reserva',
  CHECKIN: 'checkin',
  CHECKOUT: 'checkout',
};

export const alojamientoProveedorApi = {
  getListadoProyecto: (proyectoId, params = {}) =>
    pythonApiClient.get(
      `/procesos/hoteleria/alojamientos-proveedor/proyecto/${proyectoId}/listado`,
      { params }
    ),

  getEstadoCola: () =>
    pythonApiClient.get('/procesos/hoteleria/alojamientos-proveedor/cola/estado'),

  encolarReserva: (
    asignacionId,
    { forzarReenvio = false, origen = 'popup', tipoOperacion = TIPO_OPERACION.RESERVA } = {}
  ) =>
    pythonApiClient.post(
      `/procesos/hoteleria/alojamientos-proveedor/encolar/${asignacionId}`,
      null,
      {
        params: {
          forzar_reenvio: forzarReenvio,
          origen,
          tipo_operacion: tipoOperacion,
        },
      }
    ),

  encolarPendientesProyecto: (
    proyectoId,
    { forzarReenvio = false, tipoOperacion = TIPO_OPERACION.RESERVA, vigencia } = {}
  ) =>
    pythonApiClient.post(
      `/procesos/hoteleria/alojamientos-proveedor/proyecto/${proyectoId}/enviar-pendientes`,
      null,
      {
        params: {
          forzar_reenvio: forzarReenvio,
          tipo_operacion: tipoOperacion,
          ...(vigencia ? { vigencia } : {}),
        },
      }
    ),

  encolarBatch: (
    asignacionIds,
    { forzarReenvio = false, origen = 'popup', tipoOperacion = TIPO_OPERACION.RESERVA } = {}
  ) =>
    pythonApiClient.post('/procesos/hoteleria/alojamientos-proveedor/encolar-batch', {
      asignacion_ids: asignacionIds,
      forzar_reenvio: forzarReenvio,
      origen,
      tipo_operacion: tipoOperacion,
    }),

  getLogsEnvio: (asignacionId, tipoOperacion = TIPO_OPERACION.RESERVA) =>
    pythonApiClient.get(
      `/procesos/hoteleria/alojamientos-proveedor/enviar/${asignacionId}/logs`,
      { params: { tipo_operacion: tipoOperacion } }
    ),
};

export default alojamientoProveedorApi;
